export default {
    home_page_title: "Thông tin tài khoản",
    security_page_title: "Trung tâm an toàn",
    security_setting_page_title: "Trung tâm an toàn",
    security_phone_label: "Điện thoại",
    security_email_label: "Email",
    security_question_label: "Vấn đề bảo mật",
    security_unset_text: "Chưa thiết lập",
    security_setted_text: "Set",
    security_question_options: [
        "Tên của mẹ bạn là?",
        "Sinh nhật chồng/vợ của bạn là ngày?",
        "Tên của cha bạn là?",
        "Mã học sinh (mã nhân viên) của bạn là?",
        "Người bạn thân thiết nhất với bạn hồi nhỏ tên là?",
        "Tên của người có ảnh hưởng lớn nhất đến bạn?"
    ],
    password_lost_page_title: "Quên mật khẩu",
    password_reset_page_title: "Đặt lại mật khẩu",
    password_lost_account_placeholder:
        "Mời nhập vào tài khoản đã quên mật khẩu",
    empty_lost_account_tips: "Tên người dùng không thể để trống",
    iscorrect_lost_account_tips: "User does not exist",
    password_reset_new_placeholder: "Mật khẩu mới",
    password_reset_confirm_placeholder: "Xác nhận mật khẩu mới",
    password_verify_page_title: "Chứng thực thân phận",
    phone_verify_page_title: "Chứng thực thân phận",
    email_verify_page_title: "Chứng thực thân phận",
    question_verify_page_title: "Chứng thực thân phận",
    phone_reset_page_title: "Điện thoại",
    email_reset_page_title: "Email",
    question_reset_page_title: "Vấn đề bảo mật",
    phone_binding_text: "Số điện thoại liên kết của bạn là",
    email_binding_text: "Email liên kết của bạn là",
    verification_code_text: "Mã xác thực",
    resend_text: "Gửi lại",
    empty_phone_number_tips: "Mời nhập số điện thoại",
    iscorrect_phone_number_tips: "Please enter a valid phone number",
    empty_verification_code_tips: "Mời nhập mã xác thực",
    iscorrect_verification_code_tips: "Sai mã xác thực",
    password_placeholder: "Mật khẩu",
    empty_password_tips: "Nhập mật khẩu",
    iscorrect_password_tips: "Mật khẩu không đúng",
    mismatched_rule_password_tips:
        "Mật khẩu không bao gồm &, # và khoảng trắng.",
    different_confirm_password_tips: "Mật khẩu không giống nhau",
    empty_email_tips: "Mời nhập email",
    iscorrect_email_tips: "Lỗi email",
    answer_placeholder: "Giải đáp",
    empty_question_tips: "Choose a security question",
    empty_answer_tips: "Give your answer here",
    iscorrect_answer_tips: "Wrong answer",
    next_step_text: "Tiếp",
    submit_text: "Submit",
    submit_success_tips: "Success",
    submit_error_tips: "Operasyon başarısız oldu, lütfen tekrar deneyin",
    get_data_fail_tips: "Lỗi kết nối mạng\\nXin thử lại sau",
    use_other_verification_type_text: "Những phương thức liên kết khác",
    custom_support_notice:
        "Tài khoản này chưa thiết lập phương thức bảo mật. Bạn có thể click vào liên kết dưới đây trên máy tính để khiếu nại." +
        process.env.VUE_APP_ORIGIN_PROFILE
};
